









import { Component, Prop, Vue } from 'vue-property-decorator';
import Create from '@/components/shared/accounts/Create.vue';

@Component({
  components: {
    Create
  },
})
export default class AccountsCreate extends Vue {
  public theme: string = 'substrate';

  public getIconTheme() {
    this.theme = this.$store.state.setting.icon;
  }

  public mounted(): void {
    this.getIconTheme();
  }
}
